import type { EmotionJSX } from '@emotion/react/types/jsx-namespace';
import { iconSize } from '@guardian/source-foundations';
import type { IconProps } from './types';

export const SvgTickRound = ({ size }: IconProps): EmotionJSX.Element => {
	return (
		<svg
			viewBox="0 0 30 30"
			xmlns="http://www.w3.org/2000/svg"
			width={size ? iconSize[size] : undefined}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 26C21.0751 26 26 21.0751 26 15C26 8.92487 21.0751 4 15 4C8.92487 4 4 8.92487 4 15C4 21.0751 8.92487 26 15 26ZM13.05 17.3615L10.5523 14.9754L9.67347 15.8541L12.6526 20.025H13.1516L21.3527 11.5371L20.45 10.657L13.05 17.3615Z"
			/>
		</svg>
	);
};
